import React, {useEffect, useRef, useState} from 'react'
import {Button} from 'antd'
import {FUNCTIONS_URL} from '../../config'
import {FileImageOutlined, LoadingOutlined} from '@ant-design/icons'
import Projects from '../../DAL/Projects'
import { updateDoc, setDoc, doc, serverTimestamp } from 'firebase/firestore'
import {  loggerEffect } from '../../effects'


function downloadFile(uri) {
  var link = document.createElement('a')
  link.setAttribute('download', 'images.zip')
  link.href = uri
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export default function DownloadImages({ zipDownloadInitTime, zipDownloadStatus, zipUrl, id}) {
  
  const [loading, setLoading] = useState(false)
  const initialZipStatus = useRef(zipDownloadStatus)
  const [logger, setLogger] = useState({error: console.log, event: console.log})
  
  const isZipReady = zipDownloadStatus === 'completed' && zipUrl;

  useEffect(loggerEffect(setLogger), [])

  useEffect(() => {
    let intervalId;

    const checkStuckProcess = async () => {
      // Only run checks if we are technically "processing"
      if (zipDownloadStatus === 'processing' && zipDownloadInitTime) {
        
        // Handle Firestore Timestamp or standard JS Date
        const startTime = zipDownloadInitTime.toDate 
          ? zipDownloadInitTime.toDate() 
          : new Date(zipDownloadInitTime);
        
        const now = new Date();
        const diffInMinutes = (now - startTime) / 1000 / 60;

        // Condition: > 15 mins passed, still processing, and no URL generated
        if (diffInMinutes > 15 && !zipUrl) {
          console.warn("Zip generation stuck > 15 mins. Resetting status to null.");
          
          try {
            // Update Firestore to reset the status. 
            // This will propagate back via props and re-enable the button.
            await updateDoc(new Projects().docRef(id), {
              zipDownloadStatus: null
            });
            
            logger.event('Process timed out. Please try again.');
          } catch (error) {
            console.error("Error resetting stuck zip status:", error);
          }
        }
      }
    };

    // Run check immediately on mount/update
    checkStuckProcess();

    // If processing, keep checking every 1 minute
    if (zipDownloadStatus === 'processing') {
      intervalId = setInterval(checkStuckProcess, 60 * 1000);
    }

    return () => clearInterval(intervalId);
  }, [zipDownloadStatus, zipDownloadInitTime, zipUrl, id, logger]);

  useEffect(() => {
    if(zipDownloadStatus === 'processing') {
      setLoading(true)
      initialZipStatus.current = 'processing'
    } else {
      setLoading(false)
      if (initialZipStatus.current === 'processing' && zipDownloadStatus === 'completed' && zipUrl) {
        logger.event('Zip created successfully. downloading...')
        downloadFile(zipUrl)
      }
      initialZipStatus.current = zipDownloadStatus
    }
  }, [zipDownloadStatus, zipUrl])

  async function imageDownloader(force = false) {

    if (zipDownloadStatus === 'completed' && zipUrl && !force) {
      setLoading(false)
      downloadFile(zipUrl)
      return
    }

    if (zipDownloadStatus === 'processing') {
      logger.event('Your request is being processed. Please try again in a few minutes.')
      return
    }

    if(!zipDownloadStatus || zipDownloadStatus === 'failed' || zipDownloadStatus === 'expired' || force) {
      //console.log("Initiating zip download process for project id:", id)
      setLoading(true)
      try {
        const projRef = new Projects().docRef(id)
        await setDoc(doc(projRef, 'zipGenerate', 'zipGenerate'), { createdAt: serverTimestamp() })
        logger.event('Your request is being processed. Please try again in a few minutes.')
      } catch (e) {
        console.error("Error initiating zip download", e)
        setLoading(false) // Stop loading spinner if the request fails
      }
      logger.event('Your request is being processed. Please try again in a few minutes.')
    }

    /*
        setLoading(true)
        try {
          const result = await fetch(`${FUNCTIONS_URL}/utilities/downloadAllImages`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            mode: 'cors',
            body: JSON.stringify({id}),
          })

          const url = await result.text()
          downloadFile(url)
        } catch (e) {
          console.error(e)
          alert('Something went wrong!\nSome files are missing.')
        } finally {
          setLoading(false)
        }
     */     
  }

  return (
    <div>
    <Button className="margin-1" disabled={loading} onClick={()=>imageDownloader(false)}>
      <FileImageOutlined  />
      {isZipReady ? 'Download Project Information' : 'Create Project Information'}
      {loading && <LoadingOutlined />}
    </Button>
        {((zipDownloadStatus === 'completed' || zipDownloadStatus == 'failed' || zipDownloadStatus == 'expired') && !loading)  && (
          <a
            onClick={() => {
              imageDownloader(true)
            }}
            style={{ cursor: 'pointer', fontSize: '11px' }}
          >
            Regenerate
          </a>
        )}
    </div>
  )
}
